export default {"src":"/_next/static/media/inovando-icon.68290b71.svg","height":20,"width":20};